const UploadNetworkHook = {
  mounted() {
    this.banner = this.el.querySelector("[data-network-banner]");
    this.updateStatus = this.updateStatus.bind(this);

    window.addEventListener("online", this.updateStatus);
    window.addEventListener("offline", this.updateStatus);
    this.updateStatus();
  },

  destroyed() {
    window.removeEventListener("online", this.updateStatus);
    window.removeEventListener("offline", this.updateStatus);
  },

  updateStatus() {
    const online = navigator.onLine;
    if (!this.banner) return;
    if (online) {
      this.banner.classList.add("hidden");
    } else {
      this.banner.classList.remove("hidden");
    }
  }
};

export default UploadNetworkHook;
